// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wRc4","option":"styles_option__1UBE9","selected":"styles_selected__1G6cB"};